import { UnitInput } from '~/components/unit-input'
import { NUTRIENT_LABELS, NUTRIENT_UNITS, type Nutrient } from '~/data/nutrition'
import type { NutrientText } from '~/lib/nutrient-text'

/**
 * The nutrients, one field apiece: calories leading on a line of their own, the macros under
 * them, and the rest behind. Used by every form that takes a food's numbers — a food's own, a
 * quick add's — so they are asked for in one order everywhere.
 */
export function NutrientFields({
  text,
  onText,
  perSaid,
}: {
  text: NutrientText
  onText: (next: NutrientText) => void
  /** What the numbers are per, said over the grid — "per 100 g" — where they are per anything. */
  perSaid?: string | undefined
}) {
  const field = (name: Nutrient) => (
    <UnitInput
      key={name}
      value={text[name]}
      unit={NUTRIENT_UNITS[name]}
      label={NUTRIENT_LABELS[name]}
      onValue={(next) => {
        onText({ ...text, [name]: next })
      }}
    />
  )
  return (
    <div className="space-y-3">
      {perSaid !== undefined && <p className="text-sm text-ink-muted">Nutrients {perSaid}</p>}
      {field('calories')}
      <div className="grid grid-cols-3 gap-3">
        {(['protein', 'carbs', 'fat'] as const).map(field)}
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {(['fibre', 'sugar', 'saturatedFat', 'sodium'] as const).map(field)}
      </div>
    </div>
  )
}
